import { gql } from 'apollo-boost';

interface AllocationFunder {
  dbId: number;
  name: string;
}

interface AllocationRelationshipManager {
  email: string;
}

interface AllocationPortfolio {
  dbId: number;
  accountId: number;
  name: string;
  customQuestions: string; // legacy (JSON), useCustomQuestions instead
  description: string;
  years: string;
  relationshipManager: AllocationRelationshipManager | null;
  funder: AllocationFunder | null;
}

export interface InvestmentReportDates {
  reportDate1?: string | null;
  reportDate2?: string | null;
  reportDate3?: string | null;
  reportDate4?: string | null;
  reportDate5?: string | null;
  reportDate6?: string | null;
  reportDate7?: string | null;
  reportDate8?: string | null;
}

interface InvestmentTimeline {
  timelineDays1?: number | null;
  timelineDays2?: number | null;
  timelineDays3?: number | null;
  timelineDays4?: number | null;
  timelineDays5?: number | null;
  timelineDays6?: number | null;
  timelineDays7?: number | null;
  timelineDays8?: number | null;
  timelineFrom1?: string | null;
  timelineFrom2?: string | null;
  timelineFrom3?: string | null;
  timelineFrom4?: string | null;
  timelineFrom5?: string | null;
  timelineFrom6?: string | null;
  timelineFrom7?: string | null;
  timelineFrom8?: string | null;
}

interface InvestmentCore {
  dbId: number;
  cashAmount: number;
  cashDescription: string;
  goodsAmount: number;
  goodsDescription: string;
  volunteerismAmount: number;
  volunteerismDescription: string;
  servicesAmount: number;
  servicesDescription: string;
  message: string;
  programNameByDonor: string;
  tags: string[];
  donation: number;
  numAllocations: number;
  status: string;
}

interface InvestmentPortfolio {
  portfolio: AllocationPortfolio | null;
}

type AllocationInvestment = InvestmentCore &
  InvestmentReportDates &
  InvestmentTimeline &
  InvestmentPortfolio;

interface Allocation<TInvestment = AllocationInvestment> {
  dbId: number;
  investment: TInvestment;
}

export interface AllocationFieldsFragment {
  allocations: Allocation[];
}

export interface AllocationReportDatesFragment {
  allocations: Allocation<InvestmentReportDates>[];
}

// Full allocation data
export const allocationFragment = gql`
  fragment AllocationFields on Report {
    allocations {
      edges {
        node {
          dbId
          investment {
            dbId
            cashAmount
            cashDescription
            goodsAmount
            goodsDescription
            volunteerismAmount
            volunteerismDescription
            servicesAmount
            message
            servicesDescription
            programNameByDonor
            tags
            donation
            numAllocations
            status
            reportDate1
            reportDate2
            reportDate3
            reportDate4
            reportDate5
            reportDate6
            reportDate7
            reportDate8
            timelineDays1
            timelineFrom1
            timelineDays2
            timelineFrom2
            timelineDays3
            timelineFrom3
            timelineDays4
            timelineFrom4
            timelineDays5
            timelineFrom5
            timelineDays6
            timelineFrom6
            timelineDays7
            timelineFrom7
            timelineDays8
            timelineFrom8
            portfolio {
              dbId
              accountId
              name
              description
              years
              customQuestions
              relationshipManager {
                email
              }
              funder {
                dbId
                name
              }
            }
          }
        }
      }
    }
  }
`;

// Variation that returns ONLY report dates from the investment
export const allocationReportDatesFragment = gql`
  fragment AllocationReportDatesFields on Report {
    allocations {
      edges {
        node {
          investment {
            reportDate1
            reportDate2
            reportDate3
            reportDate4
            reportDate5
            reportDate6
            reportDate7
            reportDate8
          }
        }
      }
    }
  }
`;
